import axios from 'axios';
import { useStorageStore } from 'src/stores/StorageStore';
import { jwtDecode } from 'jwt-decode'

const API_URL = process.env.REACT_APP_API_URL

export const getAuthToken = ()=>{
    const storage = useStorageStore.getState();
    const token = storage.getItem("token")

    if (!token){
      window.location.replace("/")
      throw new Error("🚨 인증 토큰이 없습니다. 로그인 후 다시 시도하세요.");
    }

    try{
      const decoded = jwtDecode<{exp: number}>(token.access_token)
      const currentTime = Math.floor(Date.now()/1000)

      if (decoded.exp < currentTime){
        window.location.replace("/")
        console.warn("🚨 액세스 토큰이 만료됨. 리프레시 필요");
        return null
      }
      return token.access_token
    } catch (error){
      window.location.replace("/")
      console.error("🚨 토큰 해독 실패:", error);
      return null
    }
}

export const postToken = async(username: string, password: string, scope?:string)=>{
    const formData = new URLSearchParams();
    formData.append("username", username);
    formData.append("password", password);
    if (scope) formData.append('scope',scope)

    try{
        const response  = await axios.post(`${API_URL}/auth/token`, formData,{
            headers: {
            "Content-Type": "application/x-www-form-urlencoded"
            }
        })

        return response.data
    }
    catch(error) {
        // console.error("🚨 로그인 요청 실패:", error);
        if (axios.isAxiosError(error)) {
          if (error.response) {
            const status = error.response.status;
    
            return {
              success: false,
              message: error.response.data?.message || "서버 오류 발생",
              status: status,
            };
          }
        }
        // ✅ 서버 응답이 없는 경우 (네트워크 오류 등)
        return {
          success: false,
          message: "네트워크 오류 또는 서버 응답 없음",
          status: null,
        };
      }
}

export const postLogout = async ()=>{
  try {
    const token = getAuthToken();
        
    const response = await axios.post(`${API_URL}/auth/logout`,{},{
      headers: {
        Authorization: `Bearer ${token}`, // ✅ 인증 헤더 추가
      },
    })
    
    return response.data
  }
  catch (error) {
    console.error("🚨 유저 데이터 요청 실패:", error);

    // ✅ 서버 응답이 있는 경우 (예: 400, 401, 500 등)
    if (axios.isAxiosError(error) && error.response) {
      return "서버 오류 발생"
    }

    // ✅ 서버 응답이 없는 경우 (네트워크 오류 등)
    return "네트워크 오류 또는 서버 응답 없음"
  }
}

export const getAgreement = async ()=>{
  try{
        const response = await axios.get(`${API_URL}/agreement`)
        return response.data
      }
    catch(error){
      if(axios.isAxiosError(error)){
          if(error.response){
            const response = error.response
            return response.data
          }
        }
    } 
}